import React, { useState, useEffect } from 'react';
import './AddDoctor.css';

const API_BASE = 'https://parachadental.com/dental-api';

const AddDoctor = ({ isOpen, onClose, onSave, doctorToEdit }) => {
    const [formData, setFormData] = useState({
        doctor_name: '',
        specialization: '',
        email: '',
        phone: '',
        experience_years: '',
        qualification: '',
        bio: '',
        status: 'active'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (doctorToEdit) {
            setFormData({
                doctor_name: doctorToEdit.doctor_name || '',
                specialization: doctorToEdit.specialization || '',
                email: doctorToEdit.email || '',
                phone: doctorToEdit.phone || '',
                experience_years: doctorToEdit.experience_years || '',
                qualification: doctorToEdit.qualification || '',
                bio: doctorToEdit.bio || '',
                status: doctorToEdit.status || 'active'
            });
        } else {
            setFormData({
                doctor_name: '',
                specialization: '',
                email: '',
                phone: '',
                experience_years: '',
                qualification: '',
                bio: '',
                status: 'active'
            });
        }
        setError('');
    }, [doctorToEdit, isOpen]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            let response;
            if (doctorToEdit) {
                response = await fetch(`${API_BASE}/update-doctor.php`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: doctorToEdit.id, ...formData })
                });
            } else {
                response = await fetch(`${API_BASE}/insert-doctor.php`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
            }
            const data = await response.json();
            
            if (data.success) {
                onSave();
                onClose();
            } else {
                setError(data.error || 'Failed to save doctor');
            }
        } catch (err) {
            console.error('Error:', err);
            setError('Cannot connect to server. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-header">
                    <h2>{doctorToEdit ? 'Edit Doctor' : 'Add New Doctor'}</h2>
                    <button className="modal-close" onClick={onClose}>&times;</button>
                </div>
                {error && <div className="modal-error">{error}</div>}
                <form onSubmit={handleSubmit} className="modal-form">
                    <div className="form-row">
                        <div className="form-group"><label>Doctor Name *</label><input type="text" name="doctor_name" value={formData.doctor_name} onChange={handleChange} required /></div>
                        <div className="form-group"><label>Specialization *</label><input type="text" name="specialization" value={formData.specialization} onChange={handleChange} required /></div>
                    </div>
                    <div className="form-row">
                        <div className="form-group"><label>Email *</label><input type="email" name="email" value={formData.email} onChange={handleChange} required /></div>
                        <div className="form-group"><label>Phone *</label><input type="tel" name="phone" value={formData.phone} onChange={handleChange} required /></div>
                    </div>
                    <div className="form-row">
                        <div className="form-group"><label>Experience (Years)</label><input type="number" name="experience_years" value={formData.experience_years} onChange={handleChange} /></div>
                        <div className="form-group"><label>Qualification</label><input type="text" name="qualification" value={formData.qualification} onChange={handleChange} /></div>
                    </div>
                    <div className="form-group"><label>Bio / About</label><textarea name="bio" value={formData.bio} onChange={handleChange} rows="3" placeholder="Doctor's biography..."></textarea></div>
                    <div className="form-group"><label>Status</label><select name="status" value={formData.status} onChange={handleChange}><option value="active">Active</option><option value="inactive">Inactive</option></select></div>
                    <div className="modal-footer">
                        <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn-save" disabled={loading}>{loading ? 'Saving...' : (doctorToEdit ? 'Update' : 'Save')}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddDoctor;